function extendPIXI(PIXI) {
	PIXI.Sprite.prototype.move = function extend_PIXI_SPRITE_add_move(direction, speed = 1, delta = 1, physics_collision = null) {
		const velocity = {x: Math.cos(direction) * speed * delta, y: Math.sin(direction) * speed * delta};
		if (!physics_collision) {
			this.x += velocity.x;
			this.y += velocity.y;
			return;
		}
		if (!physics_collision(this.x + velocity.x, this.y + velocity.y)) {
			this.x += velocity.x;
			this.y += velocity.y;
		}

		if (this.walkanimationtextures && !this.walkanimationsprite) {
			this.visible = false;
			this.walkanimationsprite = new PIXI.AnimatedSprite(this.walkanimationtextures);
			this.walkanimationsprite.anchor.set(0.5);
			this.walkanimationsprite.position.copyFrom(this.position);
			this.walkanimationsprite.loop = false;
			this.walkanimationsprite.animationSpeed = 0.4;
			this.walkanimationsprite.onComplete = () => {
				this.visible = true;
				this.walkanimationsprite.destroy();
				this.walkanimationsprite = null;
			};
			this.walkanimationsprite.onFrameChange = () => {
				this.walkanimationsprite.position.copyFrom(this.position);
			};
			this.parent.addChild(this.walkanimationsprite);
			this.walkanimationsprite.play();
		}
	};
}

if (typeof module === 'object') {
	module.exports = extendPIXI;
} else {
	window.extendPIXI = extendPIXI;
}
